var exports = {
  "rY": "PlutoniumContent.module__giftModeContainer___S2FFdW",
  "rs": "PlutoniumContent.module__mainContainer___S2FFdW",
  "wx": "PlutoniumContent.module__header___S2FFdW",
  "DD": "PlutoniumContent.module__title___S2FFdW",
  "h_": "PlutoniumContent.module__description___S2FFdW",
  "xd": "PlutoniumContent.module__subscriptionSection___S2FFdW",
  "fv": "PlutoniumContent.module__disclaimerContainer___S2FFdW",
  "F4": "PlutoniumContent.module__perksSection___S2FFdW",
  "pD": "PlutoniumContent.module__comparisonTableContainer___S2FFdW",
  "MT": "PlutoniumContent.module__redeemSection___S2FFdW",
  "$r": "PlutoniumContent.module__redeemDescription___S2FFdW",
};

module.exports = exports;
